import React, { FunctionComponent } from 'react';
import { Card } from '@visalex/core';

import cx from 'clsx';

import { PostsListType, PostType, SectionType } from '../../types';

import styles from './PostsList.module.scss';

export const PostsList: FunctionComponent<PostsListType> = ({ postsList, sectionsList, handleClick }) => {
  return (
    <div className={styles.faq__list}>
      {sectionsList &&
        sectionsList.map((section: SectionType, id: number) => (
          <Card key={id} onClick={(e) => handleClick(e, section.url)}>
            <div className={cx(styles.faq__item, styles.faq__section)}>
              <h4 className={styles.faq__section_title}>
                <img src="/images/posts/section.svg" className={styles.faq__section_image} />
                <span>{section.title}</span>
              </h4>
            </div>
          </Card>
        ))}
      {postsList.map((post: PostType, id) => (
        <Card key={id} onClick={(e) => handleClick(e, post.url)}>
          <div className={cx(styles.faq__item, styles.faq__post)}>
            <div className="d-flex align-items-center">
              <img src={post.icon} className={styles.faq__post_image} />
              <div className={styles.faq__post_content}>
                <h4 className={styles.faq__post_title} data-testid="post-title">
                  {post.title}
                </h4>
                <span className={styles.faq__item_description}>{post.description}</span>
              </div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};
